import { Injectable } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { Network } from '@capacitor/network';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class NetworkService {
  public isOnline: boolean;

  constructor(
    public alertCtrl: AlertController,
    public platform: Platform,
    public translate: TranslateService
  ) {
    this.intializeNetworkStatus();
  }

  protected intializeNetworkStatus() {
    this.watchNetworkStatus();
  }

  public async watchNetworkStatus() {
    this.isOnline = (await Network.getStatus()).connected;
    Network.addListener('networkStatusChange', status => {
      this.isOnline = status.connected;
    });
  }

  public isOnlineWithAlert(): boolean {
    if (this.isOnline === false) {
      this.networkAlert();

      return false;
    }

    return true;
  }

  public async networkAlert() {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('INTERNET_REQUIRED_TITLE'),
      message: this.translate.instant('INTERNET_REQUIRED'),
      buttons: [this.translate.instant('OK')]
    });

    return alert.present();
  }
}
